import { createSlice } from "@reduxjs/toolkit";
import { LayerAlias } from "constant";

export interface ImageDetectionStateInterface {
  isUploadingImageInferenceLoading: boolean;
  uploadProgress: number;
  detections: {
    [LayerAlias.RGB]: any[];
    [LayerAlias.MULTISPECTRAL]: any[];
  };
}

const initialState: ImageDetectionStateInterface = {
  isUploadingImageInferenceLoading: false,
  uploadProgress: 0,
  detections: {
    [LayerAlias.RGB]: [],
    [LayerAlias.MULTISPECTRAL]: []
  }
};

export const mainSlice = createSlice({
  name: "imageDetection",
  initialState,
  reducers: {
    fetchUploadImageInferenceRequest: (state) => {
      state.uploadProgress = 0;
      state.isUploadingImageInferenceLoading = true;
    },
    fetchUploadImageInferenceProgress: (state, { payload }) => {
      state.uploadProgress = payload.progress;
    },
    fetchUploadImageInferenceSuccess: (state, { payload }) => {
      state.isUploadingImageInferenceLoading = false;
      state.detections[payload.params.alias] = payload.data;
    },
    fetchUploadImageInferenceError: (state) => {
      state.isUploadingImageInferenceLoading = false;
    },

    resetDetections: (state, { payload }) => {
      state.detections[payload.alias] = [];
    }
  }
});

export const { actions, reducer } = mainSlice;
